export default function logErrorHelper(error) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    return console.log(error);
  }
  return null;
}
